import "@/App.css";
import { lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { Layout } from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Industries from "@/pages/Industries";
import IndustryDetail from "@/pages/IndustryDetail";
import TechnicalServices from "@/pages/TechnicalServices";
import Elastomers from "@/pages/Elastomers";
import Quality from "@/pages/Quality";
import Contact from "@/pages/Contact";
import RequestQuote from "@/pages/RequestQuote";
import ThankYou from "@/pages/ThankYou";
import NotFound from "@/pages/NotFound";

const PortalApp = lazy(() => import("@/portal/PortalApp"));
const RollStatusPage = lazy(() => import("@/pages/RollStatusPage"));

const productionFallback = (
  <div role="status" style={{ minHeight: "100vh", display: "grid", placeItems: "center", background: "#FFF8F1", color: "#51372B", fontFamily: "Arial, Helvetica, sans-serif" }}>
    Loading production workspace…
  </div>
);

const portalFallback = (
  <div
    style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FFF8F1", color: "#8D7B73", fontFamily: "Arial, Helvetica, sans-serif" }}
    data-testid="portal-loading"
  >
    Loading portal…
  </div>
);

const SiteToaster = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith("/portal") || pathname === "/roll-status" || pathname.startsWith("/roll-status/")) return null;
  return <Toaster position="bottom-right" theme="dark" toastOptions={{ style: { background: "#1a1c1e", border: "1px solid #3a3e42", color: "#f5f5f0", borderRadius: 0 } }} />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/portal/*" element={<Suspense fallback={portalFallback}><PortalApp /></Suspense>} />
        <Route path="/roll-status/*" element={<Suspense fallback={productionFallback}><RollStatusPage /></Suspense>} />
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetail />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/industries/:slug" element={<IndustryDetail />} />
          <Route path="/technical-services" element={<TechnicalServices />} />
          <Route path="/elastomers" element={<Elastomers />} />
          <Route path="/quality" element={<Quality />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/request-a-quote" element={<RequestQuote />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
      <SiteToaster />
    </BrowserRouter>
  );
}

export default App;
